import React from "react";
import {
  Box,
  Typography,
  TextField,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
  IconButton,
} from "@mui/material";
import ShareIcon from "@mui/icons-material/Share";
import DownloadIcon from "@mui/icons-material/Download";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { marked } from "marked";
import logoMapache from "../img/logo_mapache.png"; // Importa el logo
import SistemaSIA from "./InfoPages/SistemaSIA.png"; // Importa el logo
import ConexionWifi from "./InfoPages/ConexionWifi.png"; // Importa el logo
import FAQCard from "../Components/FAQCard";
import sistemaSia from "./InfoPages/sistema_sia2026.md";
import WifiInfoPage from "./InfoPages/WifiInfoPage";
import BibliotecaVirtual from "./InfoPages/BibliotecaVirtual";
import Ufvs from "./InfoPages/UfvData";
import BibliotecaVirtualImg from "./InfoPages/BibliotecaVirtual.png";
// Importa el contenido de conexión WiFi
// Contenidos definidos localmente
const contenidos = [
  {
    nombre: "¿Cómo conectarse al WiFi CONTA P.U.E.S?",
    slug: "wifi-conta-pues",
    tipo: "jsx",
    contenido: () => <WifiInfoPage />,
    imagen: ConexionWifi,
  },
  {
    nombre: "UFVs (Unidad de Fomento a la Vivienda)",
    slug: "ufvs",
    tipo: "jsx",
    contenido: () => <Ufvs />,
    imagen: null,
  },
  {
    nombre: "Biblioteca Virtual",
    slug: "biblioteca-virtual",
    tipo: "jsx",
    contenido: () => <BibliotecaVirtual />,
    imagen: BibliotecaVirtualImg,
  },
  {
    nombre: "Sistema SIA 2026",
    slug: "sistema-sia",
    tipo: "md",
    contenido: sistemaSia,
    imagen: SistemaSIA,
  },
];

const FAQPage = () => {
  const [filtro, setFiltro] = React.useState("");
  const navigate = useNavigate();
  const { slug } = useParams();

  const [contenidoHTML, setContenidoHTML] = React.useState("");
  const contenidoSeleccionado = contenidos.find(
    (c) => c.slug === slug
  );
  const filtrados = contenidos.filter((c) =>
    c.nombre.toLowerCase().includes(filtro.toLowerCase())
  );

  React.useEffect(() => {
    if (contenidoSeleccionado?.tipo === "md") {
      const contenido = contenidoSeleccionado.contenido;
      if (contenido.startsWith("/")) {
        // Es una URL, lo cargamos
        fetch(contenido)
          .then((res) => res.text())
          .then((text) => setContenidoHTML(marked.parse(text)));
      } else {
        // Es contenido directo
        setContenidoHTML(marked.parse(contenido));
      }
    }
  }, [contenidoSeleccionado]);

  const handleClick = (slug) => {
    navigate(`/informate/${slug}`);
  };

  const handleVolver = () => {
    navigate("/informate");
  };

  const handleCompartir = () => {
    const url = encodeURIComponent(window.location.href);
    const text = encodeURIComponent(
      `¡Revisa este contenido de Conta PUES!\n\n${contenidoSeleccionado.nombre}\n`
    );

    const links = {
      whatsapp: `https://wa.me/?text=${text}%20${url}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
    };

    // Puedes mostrar un menú o abrir directamente una red
    window.open(links.whatsapp, "_blank");
  };

  const handleDescargar = () => {
    const content = document.getElementById("contenido-pdf");
    const clone = content.cloneNode(true);

    // Crear encabezado personalizado
    const header = document.createElement("div");
    header.style.textAlign = "center";
    header.style.marginBottom = "20px";

    // Logo base64 (reemplaza con tu logo real en base64)
    const logo = new Image();
    logo.src = logoMapache;
    logo.style.width = "60px";
    logo.style.marginBottom = "10px";
    header.appendChild(logo);

    const titleCE = document.createElement("div");
    titleCE.innerText = "C.E Conta PUES";
    titleCE.style.fontSize = "14px";
    titleCE.style.fontWeight = "bold";
    header.appendChild(titleCE);

    const titleContent = document.createElement("div");
    titleContent.innerText = contenidoSeleccionado.nombre;
    titleContent.style.fontSize = "22px";
    titleContent.style.fontWeight = "bold";
    titleContent.style.marginBottom = "20px";
    header.appendChild(titleContent);

    // Insertar encabezado al principio del contenido
    clone.insertBefore(header, clone.firstChild);

    // Configuración de pdf
    const opt = {
      margin: 10,
      filename: `${contenidoSeleccionado.nombre}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: {
        unit: "mm",
        format: "letter",
        orientation: "portrait",
      },
    };

    window.html2pdf().set(opt).from(clone).save();
  };

  return (
    <Box p={2}>
      <Helmet>
        <title>
          {contenidoSeleccionado
            ? contenidoSeleccionado.nombre
            : "Infórmate - PUES"}
        </title>
        <meta
          name="description"
          content={
            contenidoSeleccionado
              ? `Consulta sobre: ${contenidoSeleccionado.nombre}`
              : "Material de apoyo e información útil para estudiantes"
          }
        />
      </Helmet>

      {!slug ? (
        <>
          <Typography variant="h4" gutterBottom>
            Infórmate
          </Typography>

          <TextField
            fullWidth
            label="Buscar información..."
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
            sx={{ mb: 3 }}
          />

          <Grid container spacing={2}>
            {filtrados.map((item) => (
              <Grid item xs={12} sm={6} md={4} key={item.slug}>
                <FAQCard
                  titulo={item.nombre}
                  imagen={item.imagen}
                  resumen={""}
                  onVerMas={() => handleClick(item.slug)}
                />
              </Grid>
            ))}
          </Grid>
        </>
      ) : contenidoSeleccionado ? (
        <>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Button
              startIcon={<ArrowBackIcon />}
              onClick={handleVolver}
              sx={{ mb: 2 }}
            >
              Volver
            </Button>

            <Box>
              <IconButton onClick={handleCompartir}>
                <ShareIcon />
              </IconButton>
              <IconButton onClick={handleDescargar}>
                <DownloadIcon />
              </IconButton>
            </Box>
          </Box>

          <Box id="contenido-pdf">
            <Typography variant="h5" gutterBottom>
              {contenidoSeleccionado.nombre}
            </Typography>

            {contenidoSeleccionado.tipo === "md" ? (
              <Box
                dangerouslySetInnerHTML={{ __html: contenidoHTML }}
              />
            ) : (
              <Box>{contenidoSeleccionado.contenido()}</Box>
            )}
          </Box>
        </>
      ) : (
        <Typography variant="h6" color="error">
          Contenido no encontrado
        </Typography>
      )}
    </Box>
  );
};

export default FAQPage;
